"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GridLayout = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var GridLayout = function () { return (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("rect", { width: "10.5", height: "6", x: "1.5", y: "1.5", fill: "currentColor", opacity: "0.72", rx: "1" }),
    react_1.default.createElement("path", { fill: "currentColor", d: "M14.25 2.5a1 1 0 011-1h6.25a1 1 0 011 1v10.75a1 1 0 01-1 1h-6.25a1 1 0 01-1-1V2.5z" }),
    react_1.default.createElement("path", { fill: "currentColor", d: "M14.25 17.5a1 1 0 011-1h6.25a1 1 0 011 1v4a1 1 0 01-1 1h-6.25a1 1 0 01-1-1v-4z", opacity: "0.72" }),
    react_1.default.createElement("path", { fill: "currentColor", d: "M1.5 10.75a1 1 0 011-1H11a1 1 0 011 1V21.5a1 1 0 01-1 1H2.5a1 1 0 01-1-1V10.75z" }))); };
exports.GridLayout = GridLayout;
//# sourceMappingURL=grid-layout.js.map